import { MathUtils, Point, Rectangle } from '@printu/geom';
import { snapToPixel } from './math';
export const svgPoint = (point) => `${point.x.toFixed(4)} ${point.y.toFixed(4)}`;
export const pointsToPathData = (points) => {
    const [anchor, ...pathPoints] = points;
    return [
        anchor,
        pathPoints.reduce((accum, point) => `${accum} L ${svgPoint(Point.from(point).subtract(anchor))}`, 'M 0 0') + ' Z',
    ];
};
export const applyCrop = (rect, crop) => {
    if (!rect || !crop) {
        return rect;
    }
    if (Rectangle.from(crop).isEmpty()) {
        return rect;
    }
    const x = snapToPixel(rect.x + rect.width * crop.x);
    const y = snapToPixel(rect.y + rect.height * crop.y);
    const width = snapToPixel(rect.width * crop.width);
    const height = snapToPixel(rect.height * crop.height);
    return { x, y, width, height };
};
export const getGradientPoints = (bounds, rotation) => {
    // from https://observablehq.com/@danburzo/css-gradient-line
    const { width, height } = bounds;
    const center = Point.from(width * 0.5, height * 0.5);
    const angle = MathUtils.degToRad(rotation);
    const acos = Math.cos(angle);
    const asin = Math.sin(angle);
    const gradientRadius = 0.5 * (Math.abs(width * acos) + Math.abs(height * asin));
    const gx = gradientRadius * acos;
    const gy = gradientRadius * asin;
    return {
        p0: { x: center.x - gx, y: center.y - gy },
        p1: { x: center.x + gx, y: center.y + gy },
    };
};
export const createLinearGradient = (id, bounds, rotation, colors) => {
    const { p0, p1 } = getGradientPoints(bounds, rotation);
    const stops = colors.map((color, index, arr) => ({
        offset: index / arr.length,
        color,
    }));
    return { id, p0, p1, stops };
};
